// extracted by mini-css-extract-plugin
module.exports = {"hotkey":"SaleOptions_hotkey__3mXcV","badge":"SaleOptions_badge__35sy6","iconButton":"SaleOptions_iconButton__2ZqVr"};